import store from '@/store'
import {routes} from '@/router'
import {prefixPath} from '@/config'
/**
 * 时间戳转换
 * 月(M)、日(d)、小时(h)、分(m)、秒(s)、季度(q) 可以用 1-2 个占位符
 * 年(y)可以用 1-4 个占位符，毫秒(S)只能用 1 个占位符(是 1-3 位的数字)
 * @param {Number} tamp 时间戳
 * @param {String} fmt 格式
 */
export function timeFormat (tamp, fmt) {
  let d = new Date(tamp)
  fmt = fmt || 'yyyy-MM-dd'
  if (!d || !tamp) return ''
  let o = {
    'M+': d.getMonth() + 1, //月份
    'd+': d.getDate(), //日
    'h+': d.getHours() % 12 == 0 ? 12 : d.getHours() % 12, //小时
    'H+': d.getHours(), //小时
    'm+': d.getMinutes(), //分
    's+': d.getSeconds(), //秒
    'q+': Math.floor((d.getMonth() + 3) / 3), //季度
    'S': d.getMilliseconds() //毫秒
  }
  let week = {
    '0': '/u65e5',
    '1': '/u4e00',
    '2': '/u4e8c',
    '3': '/u4e09',
    '4': '/u56db',
    '5': '/u4e94',
    '6': '/u516d'
  }
  if (/(y+)/.test(fmt)) {
    fmt = fmt.replace(RegExp.$1, (d.getFullYear() + '').substr(4 - RegExp.$1.length))
  }
  if (/(E+)/.test(fmt)) {
    fmt = fmt.replace(RegExp.$1, ((RegExp.$1.length > 1) ? (RegExp.$1.length > 2 ? '/u661f/u671f' : '/u5468') : '') + week[d.getDay() + ''])
  }
  for (let k in o) {
    if (new RegExp('(' + k + ')').test(fmt)) {
      fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (('00' + o[k]).substr(('' + o[k]).length)))
    }
  }
  return fmt
}
export function secondToHour (second, type = 'hh:mm') {
  let hour = parseInt(second / 3600)
  let minute = parseInt(second / 60) % 60
  let secon = second % 60
  switch (type) {
    case 'hh:mm:ss':
      return hour + ':' + minute + ':' + secon
    default:
      return hour + ':' + minute + ':'
  }
}
/**
 * @description 根据当前路由获取面包屑
 * @params {Array} menus 菜单列表
 * @params {String} name 当前路由name
 * @return {Array} routes 当前路由列表
 */
export const getMenuByRouter = (menus, name) => {
  let routes = []
  //获取面包屑组件
  let crumbsList = sessionStorage.getItem('crumbsList')
  menus.some(menu => {
    if (menu.children && menu.children.length) {
      if (routes.length <= 1) routes.length = 0
      else return routes
      routes.push(menu)
      menu.children.some(childMenu => {
        if (name === childMenu.menuCode) {
          return routes.push(childMenu)
        }
      })
    }
  })
  if (routes.length <= 1) {
    crumbsList = crumbsList && JSON.parse(crumbsList)
    crumbsList && (routes = crumbsList)
  } else sessionStorage.removeItem('crumbsList')
  store.commit('CRUMBS_LIST', routes)
  return routes
}
/**
 * @description 根据当前路由名称获取面包屑
 * @params {Array} menus 菜单列表
 * @params {String} name 当前路由name
 * @return {Array} routes 当前路由列表
 */
export const getMenuNameByRouter = () => {
  let menuNames = {}
  return (name) => {
    if (menuNames[name]) return menuNames[name]
    const menuList = routes[1].children
    const eachName = function (list) {
      list.some(item => {
        if (item.name === name) {
          return (menuNames[name] = item.meta.title)
        }
        if (item.children && item.children.length) {
          eachName(item.children)
        }
      })
    }
    eachName(menuList)
    return menuNames[name]
  }
}
/**
  *[imagePath {Function} 全局图片路径处理函数 ]
  * @param {string} type 图片类型，根据类型判断返回默认图片
  * @param {string} 图片Id 没有则为空，返回对应类型默认图片
  * @returns {string} 返回合并后图片路径
  */
export const imagePath = (type, imgId) => {
  if (!type) throw new Error('请输入图片类型')
  if (imgId) {
    return `../${prefixPath}api-file/portal/file/stream/${imgId}?origin=true`
  }
  switch (type) {
    case 'course' :
      return import('@/static/images/course/cover-image-1.png')
    case 'headImg' :
      return import('@/static/images/user/header-3.png')
    case 'user' :
      return import('@/static/images/user/header-3.png')
    case 'album' :
      return '../../static/images/album-default.png'
    case 'zero' :
      return import('@/static/images/zero.png')
  }
}
/**
  *[levelLinkage {Function} 联动关系处理方法 ]
  * @param {Array} arr 存放ref、isLink的数组
  * @param ref 组件的ref属性
  * @param isLink 是否需要上级的value作为本请求的参数, true不需要   false需要或不传
  * 需配合 data-dictionary组件使用
*/
export const levelLinkage = function (arrs, obj) {
  arrs.forEach((item, index) => {
    let ref = this.$refs[item.ref]
    if (ref.alreadySelect) {
      let a = ref.alreadySelect
      if (arrs[index + 1]) {
        this.$refs[arrs[index + 1].ref].getDictionary(a)
      } else {
        return false
      }
    }
    ref.$on('on-change', function (val) {
      onChange({
        val,
        index
      })
    })
  })
  const onChange = ({val, index}) => {
    let refNext
    let isLink
    if (arrs[index + 1]) {
      refNext = this.$refs[arrs[index + 1].ref]
      isLink = arrs[index + 1].isLink
      refNext.clearOption()
    } else {
      isLink = null
      refNext = this.$refs[arrs[index].ref]
    }
    if (val) {
      if (!isLink) {
        refNext.getDictionary(val, obj)
      } else {
        refNext.getDictionary()
      }
    }
  }
}
/**
  *[hasClass {Function} 判断当前dom是否拥有某class ]
  * @param {Object} obj 当前dom对象
  * @param {String} cls class名
*/
export const hasClass = function (obj, cls) {
  return obj.className.match(new RegExp('(\\s|^)' + cls + '(\\s|$)'))
}
/**
  *[addClass {Function} 给当前dom对象添加类名 ]
  * @param {Object} obj 当前dom对象
  * @param {String} cls class名
  * 需配合hasClass方法使用
*/
export const addClass = function (obj, cls) {
  if (!hasClass(obj, cls)) obj.className += ' ' + cls
}
/**
  *[removeClass {Function} 删除当前dom对象的某个类名 ]
  * @param {Object} obj 当前dom对象
  * @param {String} cls class名
  * 需配合hasClass方法使用
*/
export const removeClass = function (obj, cls) {
  if (hasClass(obj, cls)) {
    var reg = new RegExp('(\\s|^)' + cls + '(\\s|$)')
    obj.className = obj.className.replace(reg, ' ')
  }
}
/**
  *[toggleClass {Function} 切换当前dom的某个类名 ]
  * @param {Object} obj 当前dom对象
  * @param {String} cls class名
  * 需配合hasClass、addClass、removeClass方法使用
*/
export const toggleClass = function (obj, cls) {
  if (hasClass(obj, cls)) {
    removeClass(obj, cls)
  } else {
    addClass(obj, cls)
  }
}
/**
  *[fomatFloat {Function} 浮点数取值 ]
  * @param {Number} src 要取的值
  * @param {Number} pos 取几位小数
*/
export const fomatFloat = function (src, pos) {
  return Math.round(src * Math.pow(10, pos)) / Math.pow(10, pos)
}
/**
  *[getFileSize {Function} 转换文件大小 ]
  * @param {Number} size 要取的值
  * @param {Number} pos 取几位小数
*/
export const getFileSize = function (size, pos) {
  let fileSizeByte = size || 0
  let currentSize = 0
  let currentDesc = ''
  if (fileSizeByte < 1048576) {
    currentSize = fomatFloat(fileSizeByte / 1024, pos)
    currentDesc = 'K'
  } else if (fileSizeByte == 1048576) {
    currentSize = '1'
    currentDesc = 'M'
  } else if (fileSizeByte > 1048576 && fileSizeByte < 1073741824) {
    currentSize = fomatFloat(fileSizeByte / (1024 * 1024), pos)
    currentDesc = 'M'
  } else if (fileSizeByte > 1048576 && fileSizeByte == 1073741824) {
    currentSize = '1'
    currentDesc = 'G'
  } else if (fileSizeByte > 1073741824 && fileSizeByte < 1099511627776) {
    currentSize = fomatFloat(fileSizeByte / (1024 * 1024 * 1024), pos)
    currentDesc = 'G'
  } else {
    currentSize = '1'
    currentDesc = 'T'
  }
  let sizeDesc = currentSize + currentDesc
  return sizeDesc
}
//query转换字符串
export const stringifyQuery = function (obj) {
  function encode (str) {
    return encodeURI(str)
  }
  let res = obj ? Object.keys(obj).map(function (key) {
    let val = obj[key]
    if (val === undefined) {
      return ''
    }
    return encode(key) + '=' + encode(val)
  }).filter(function (x) { return x.length > 0 }).join('&') : null
  return res ? ('?' + res) : ''
}
export const getImgType = function (item) {
  let a = item.substring(item.lastIndexOf('.') + 1)
  let b = ''
  if (a == 'xlsx') {
    b = 'xls'
  } else if (a == 'jpg' || a == 'png' || a == 'gif' || a == 'jpeg') {
    b = 'img'
  } else if (a == 'docx') {
    b = 'doc'
  } else if (a == 'txt') {
    b = 'txt'
  } else if (a == 'pdf') {
    b = 'pdf'
  } else if (a == 'mp4') {
    b = 'mp4'
  } else if (a == 'mp3') {
    b = 'mp4'
  } else if (a == 'zip') {
    b = 'zip'
  } else {
    b = 'xml'
  }
  return b
}
export const oneOf = function (value, validList) {
  //逆向操作，复杂度由O(n)变成O(1)
  for (let i = validList.length; i >= 0; i--) {
    if (value === validList[i]) return true
  }
  return false
}



// WEBPACK FOOTER //
// ./src/utils/index.js